import { render, staticRenderFns } from "./search-report.vue?vue&type=template&id=65fbbdea&scoped=true"
import script from "./search-report.vue?vue&type=script&lang=js"
export * from "./search-report.vue?vue&type=script&lang=js"
import style0 from "./search-report.vue?vue&type=style&index=0&id=65fbbdea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fbbdea",
  null
  
)

export default component.exports